import { useTranslation } from '@mc/i18n'
import { PageSource } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import { trackCatalogPageRowViewed } from '../../../events'
import { useBelowTheFoldData, usePageData } from '../../PageDataProvider'
import { MainCategoryInstructorCarousel } from './MainCategoryInstructorCarousel'

export const MainCategoryCarouselSection = () => {
  const { category, slug } = usePageData()
  const { content } = useBelowTheFoldData()
  const { t } = useTranslation('@mc/next')

  const totalInstructorsText = t(
    'categories.categoryPage.subcategoryInstructorCarousel.totalInstructorsCarousel',
    {
      contentLength: content.length,
      categoryName: category?.name,
    },
  )

  return (
    <TrackingContainer
      onFirstVisible={() =>
        trackCatalogPageRowViewed({
          rowName: `main_category_carousel:${totalInstructorsText}`,
          categorySlug: slug,
        })
      }
    >
      <MainCategoryInstructorCarousel
        TitleComponent={<h3 className='mc-text-h4'>{totalInstructorsText}</h3>}
        content={content}
        carouselName={totalInstructorsText}
        categorySlug={slug}
        trackProps={{
          categorySlug: slug,
          pageSource: PageSource.CATEGORY,
          rowIndex: 2,
          carousel: 'main_category_carousel',
        }}
      />
    </TrackingContainer>
  )
}
